// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__narkis_8470fa', '__narkis_Fallback_8470fa'"},"className":"__className_8470fa","variable":"__variable_8470fa"};